import { array, nonEmptyArray } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import {
    NewRoutingRuleAssignment,
    NewRoutingRuleResult,
    RoutingRulePrepayment,
    RoutingRuleRateAssignment,
} from '@mews-commander/data-access';
import { RoutingRuleConditionRate, RoutingRuleConditions } from '../types';
import { getRoutingRuleAssignments } from './newRoutingRuleResult';

export const getRoutingRuleRates = (
    rateAssignments: RoutingRuleRateAssignment[],
    routingRuleAssigments: NewRoutingRuleAssignment[]
): RoutingRuleConditionRate[] => {
    const rateAssignmentsGroupedByRoutingRuleAssignmentId: Record<string, RoutingRuleRateAssignment[]> = pipe(
        rateAssignments || [],
        nonEmptyArray.groupBy((rateAssignment) => rateAssignment.routingRuleAssignmentId)
    );

    return pipe(
        routingRuleAssigments,
        array.map((assignment) => ({
            serviceId: assignment.serviceId,
            serviceName: assignment.serviceName,
            rates:
                rateAssignmentsGroupedByRoutingRuleAssignmentId[assignment.id]?.map((rateAssignment) => ({
                    id: rateAssignment.rateId,
                    name: rateAssignment.rateName,
                })) ?? [],
        }))
    );
};

export const getRoutingRuleConditions = (result: NewRoutingRuleResult, index: number): RoutingRuleConditions => {
    if (!result.routingRuleAssignments || !result.routingRules || index >= result.routingRules.length) {
        return {
            travelAgencies: [],
            companies: [],
            rates: [],
            guestProfiles: [],
            reservationGroupIds: [],
            reservationIds: [],
            prepayment: false,
        };
    }

    const { travelAgencies, companies } = result.routingRules[index].companiesWithRelations.reduce(
        (acc: Pick<RoutingRuleConditions, 'companies' | 'travelAgencies'>, companyWithRelation) => {
            const companyToPush = { id: companyWithRelation.companyId, name: companyWithRelation.companyName };

            if (companyWithRelation.companyRelations.partnerCompany) {
                acc.companies.push(companyToPush);
            }
            if (companyWithRelation.companyRelations.travelAgency) {
                acc.travelAgencies.push(companyToPush);
            }
            return acc;
        },
        { travelAgencies: [], companies: [] }
    );

    return {
        travelAgencies,
        companies,
        rates: getRoutingRuleRates(result.rateAssignments ?? [], getRoutingRuleAssignments(result, index)),
        prepayment: result.routingRules[index].prepayment === RoutingRulePrepayment.Prepaid,
        // @ts-expect-error $TSFixMeError: Property 'guestProfiles' does not exist on type 'NewRoutingRule'
        guestProfiles: result.routingRules[index].guestProfiles ?? [],
        // @ts-expect-error $TSFixMeError: Property 'reservationGroupIds' does not exist on type 'NewRoutingRule'
        reservationGroupIds: result.routingRules[index].reservationGroupIds ?? [],
        // @ts-expect-error $TSFixMeError: Property 'reservationIds' does not exist on type 'NewRoutingRule'
        reservationIds: result.routingRules[index].reservationIds ?? [],
    };
};
